


















// @ is an alias to /src
import Vue from "vue";
import {OrderRepo, IOrderInfo} from '../libs/OrderRepository'

export default Vue.extend({
  name: "Home",
  components: {
  },
  data() {
    return {   
      orderStatus : undefined as IOrderInfo | undefined
    };
  },
  methods: {
  
  },
  mounted: async function() {
    var self = this;
    console.log(this.$route.query.orderId.toString());
    this.orderStatus = await OrderRepo.getOrderInfo(this.$route.query.orderId.toString());
    console.log(this.orderStatus);
    if(this.orderStatus?.code !== undefined){
      localStorage.setItem(this.orderStatus.routeId, this.orderStatus.code);
      setTimeout(function(){
        self.$router.push('/route/'+ self.orderStatus?.routeId);
      }, 6000)
    }
  },
  watch: {
   
  },
  computed: {
  }
});
